export default __webpack_public_path__ + "static/burredgroove-0bd445ad6c596de7444e81295bae2ae2.png";